import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19a25a3c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-black" }
const _hoisted_2 = { class: "container header-container d-flex justify-content-between pt-4" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "developers pb-4" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "m-0 text-white" }, "#47Poligons"),
  /*#__PURE__*/_createElementVNode("small", { style: {"color":"#8b9296"} }, "Web-studio"),
  /*#__PURE__*/_createElementVNode("div", { id: "detect" })
], -1))
const _hoisted_4 = { class: "agreements d-flex flex-column pb-4" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Информация", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Правовая информация / Copyright policy", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Политика конфиденциальности / Privacy policy", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Использование Cookie / Cookie usage", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "social d-flex flex-column pb-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Контакты"),
  /*#__PURE__*/_createElementVNode("small", { class: "text-white" }, [
    /*#__PURE__*/_createTextVNode("Сотрудничество и предложения "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("по развитию проекта - "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "mailto:47Poligons@gmail.com",
      style: {"color":"white"}
    }, "47Poligons@gmail.com")
  ]),
  /*#__PURE__*/_createElementVNode("small", { style: {"color":"#8b9296"} }, "Заметили ошибку? Напишите нам")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _createVNode(_component_router_link, { to: {name: 'copyright_abuse'} }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: {name: 'privacy_policy'} }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, { to: {name: 'cookie_usage'} }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      _hoisted_9
    ])
  ]))
}